import { lazy } from 'react';

export const InvokeAllScriptsButton = lazy(() =>
  import(/* webpackChunkName: "Experiments" */ './InvokeAllScriptsButton').then((module) => ({
    default: module.InvokeAllScriptsButton,
  }))
);
